<template>
  <div class="ms-icon" :class="[mappingColor2Class[color], size, icon, customClass]" v-tooltip="tooltip"></div>
</template>

<script>
import {defineComponent} from 'vue';
export default defineComponent({
  name: 'MsIcon',
  props: {
    /**
     * Chứa tên class của icon
     */
    icon: {
      type: String,
      default: '',
    },
    /**
     * icon16, icon24, icon36, icon20 icon30,... được define trong icons.scss
     */
    size: {
      type: String,
      default: 'icon24',
    },
    /**
     * tạm thời để bình thường nếu disabled thì phải định nghĩa trong icons.scss
     */
    color: {
      type: String,
      default: '',
    },
    tooltip: {
      type: String,
      default: '',
    },
    customClass: {
      type: String,
      default: '',
    },
  },
  setup() {
    const mappingColor2Class = {
      info: 'info',
      disabled: 'disabled',
    };

    return {
      mappingColor2Class,
    };
  },
});
</script>

<style>
</style>